import { Switch as AntSwitch } from 'antd'
import type { ComponentProps } from 'react'

type AntSwitchProps = ComponentProps<typeof AntSwitch>

export interface AppSwitchProps extends AntSwitchProps {}

export const AppSwitch = ({ ...rest }: AppSwitchProps) => <AntSwitch {...rest} />
